export const CATEGORY_ORDER = [
  { slug: "contenu", num: "01" },
  { slug: "reseaux-sociaux", num: "02" },
  { slug: "branding", num: "03" },
  { slug: "print", num: "04" },
];

// Vision pillar slug -> services category slug (same order as CATEGORY_ORDER)
export const PILLAR_TO_CATEGORY = {
  "creation-de-contenu": "contenu",
  "social-media-management": "reseaux-sociaux",
  "branding-identite-visuelle": "branding",
  "creations-print": "print",
};

export const PILLAR_SLUGS = Object.keys(PILLAR_TO_CATEGORY);
